import api from "./core";

const basePath = "api/portal/Accesses";

export default {
  patientsByCode(code) {
    return api.get(`${basePath}/Patients/${code}`);
  },
  patientsByAuth() {
    return api.get(`${basePath}/Patients`);
  },
  queryById(id, patientId) {
    return api.post(`${basePath}/FindById/${id}${patientId? '?patientId='+ patientId : ''}`);
  }
};
